// extracted by mini-css-extract-plugin
export default {"buttonReset":"controls_buttonReset__do5Bj","linkButton":"controls_linkButton__rzvtw"};